import { graphql } from 'gatsby'
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import ProjectModel from '../../datas/models/Project'
import asTemplate from '../../root/Template'
import { withTransformer } from '../../utils/GatsbyUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { localize } from '../../utils/TranslationUtils'
import { ParallaxTitle, Portfolio, ScrollWatcher, SectionUptitle } from '../../components'
import Seo from '../../components/Seo'

import styles from './styles'
import ProjectHeader from './ProjectHeader'
import ProjectPhotos from './ProjectPhotos'
import ProjectDescription from './ProjectDescription'


const mapSelectors = () => ({
  //
})

const mapActions = dispatch => ({
  //
})

function transformer(data) {
  const { contentfulProject, allContentfulProject} = data


  if (contentfulProject) {
    const shuffled = allContentfulProject?.edges?.sort(() => 0.5 - Math.random())?.slice(0, 3)

    return {
      project: ProjectModel(contentfulProject),
      relatedProjects: shuffled?.map(({ node }) => ProjectModel(node))
    }
  }
}

const decorators = [
  asTemplate,
  localize,
  withTransformer(transformer),
  connect(mapSelectors, mapActions),
  memoized,
]

function ProjectTemplate(props) {
  const { project, relatedProjects, t, locale } = props

  const shouldShowArrows = scrollTop => scrollTop <= 50
  const [showArrows, setShowArrows] = React.useState(shouldShowArrows(ScrollWatcher.scrollTop))
  const handleScroll = scrollTop => setShowArrows(shouldShowArrows(scrollTop))


  return (
    <>
      <Seo {...project.seo} />
      <ScrollWatcher onChange={handleScroll} />
      <section className="header">
        <ProjectHeader
          title={project.title}
          baseline={project.subTitle}
          domain={project.domain.slug}
          locale={locale}
          label={project.domain.domain}
        />
      </section>
      <section className="photos">
        <ProjectPhotos
          key={project.slug}
          pictures={project.pictures}
        />
      </section>
      <section className="description">
        <ProjectDescription
          t={t}
          description={project.description}
          technologiesLabel={t('technologies')}
          technologies={project.technologies}
          creditsLabel={t('credits')}
          credits={project.credits}
          sectorLabel={t('sector')}
          sector={project.sector}
          tags={project.tags}
          qrCode={project.qrcode}
          link={project.link}
        />
      </section>
      {relatedProjects && relatedProjects.length > 0
      && (
        <section className="projects">
          <div className="project-content">
            <div className='title'>
              <SectionUptitle title={t('moreProjects')} />
              <ParallaxTitle title={t('moreProjectsParallax')} parallax={{ translateY: [-30, 10] }} />
            </div>
            <Portfolio
              projects={relatedProjects}
              locale={locale}
              swiper={{
                breakpoints: {
                  0: {
                    slidesPerView: 1.3,
                    spaceBetween: 30
                  },
                  960: {
                    slidesPerView: 3,
                    spaceBetween: 50
                  }
                }
              }}
            />
          </div>
        </section>
        )
      }
      <style jsx>{styles}</style>
    </>
  )
}

ProjectTemplate.propTypes = {
  project: ProjectModel.propTypes,
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
}

ProjectTemplate.defaultProps = {
  project: ProjectModel.defaultProps,
}

ProjectTemplate = chainDecorators(decorators, ProjectTemplate)

export default ProjectTemplate

export const query = graphql`
    query($langKey: String!, $slug: String!, $domainSlug: String!) {
        contentfulProject(node_locale: { eq: $langKey }, slug: { eq: $slug }) {
            ...bbsContentfulProjectDetail
        }
        allContentfulProject(filter: { node_locale: { eq: $langKey } slug: { nin: [$slug] } domain: { slug: { in: [$domainSlug] } } }) {
          edges {
            node {
              ...bbsContentfulProjectDetail
            }
          }
        }
        allContentfulDomain(filter: { node_locale: { eq: $langKey } }, sort:  { fields: order, order: ASC }) {
          edges {
            node {
              ...bbsContentfulDomain
            }
          }
        }
    }
`
